import { useEffect, useContext, useState, useMemo } from 'react'
// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'

import { Link as MuiLink, Stack } from '@mui/material'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDSnackbar from 'components/MDSnackbar'
import MDButton from 'components/MDButton'

// Material Dashboard 2 PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import DataTable from 'components/Tables/DataTable'

// zerouno
import documentService from 'services/document.service'
import { Link, useNavigate, useParams } from 'react-router-dom'
import ZUTitleForm from 'components/ZeroUno/ZUTitleForm'
import RabbitContext from 'context/rabbit.js'
import { config } from 'variables/Config.js'

export default function DocumentTable () {
  const [objects, setObjects] = useState([])
  const [objId, setObjId] = useState(0)
  const { idCustomer } = useParams()
  const [showSnackbar, setShowSnackbar] = useState({ sh: false, msg: '', color: 'success' })
  const [openConfirm, setOpenConfirm] = useState(false)
  const { rabbit } = useContext(RabbitContext)
  const navigate = useNavigate()

  useEffect(() => {
    fetchObjects()
  }, [])

  const fetchObjects = () => {
    documentService.getAll(idCustomer).then(
      (response) => {
        setObjects(response.data)
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  // Delete
  const deleteObject = () => {
    setOpenConfirm(false)
    documentService.remove(idCustomer, objId).then(
      (response) => {
        setShowSnackbar({ sh: true, msg: 'operazione effettuata con successo', color: 'success' })
        fetchObjects()
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  const columns = [
    {
      Header: 'documento',
      accessor: 'name'
    },
    {
      Header: 'azioni',
      sortable: false,
      filterable: false,
      width: 100,
      accessor: 'id',
      Cell: ({ value, row }) => {
        return (
          <Stack direction='row' spacing={1}>
            <MDButton
              color='info'
              size='small'
              iconOnly
              component={Link}
              to={'/customers/' + idCustomer + '/documents/' + value}
            >
              <Icon>edit</Icon>
            </MDButton>
            <MDButton
              iconOnly
              color='error'
              size='small'
              onClick={() => {
              	setObjId(value)
              	setOpenConfirm(true)
            	}}
            >
              <Icon>delete</Icon>
            </MDButton>
            {row.original.file &&
              <MDButton
                size='small'
                color='success'
                sx={{ mx: 2 }}
                href={config.SERVER_URL + '/download/' + row.original.file}
                target='_blank'
              >
                download
              </MDButton>}
          </Stack>
        )
      }
    }
  ]

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <ZUTitleForm bgColor='info' title='Documenti' icon='description' />
          <MDBox sx={{ p: 3 }} lineHeight={1}>
            <MDButton color='info' component={Link} to={`/customers/${idCustomer}/documents/new`} m={1}>
              aggiungi
            </MDButton>
            <MDButton
              variant='gradient' color='secondary' component={Link} to={`/customers/${idCustomer}/documents`}
            >
              Indietro
            </MDButton>
          </MDBox>

          <DataTable table={{ columns: columns, rows: objects }} canSearch />
        </Card>
      </MDBox>
      <Footer />
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Confermi eliminazione?
        </DialogTitle>
        <DialogActions>
          <MDButton onClick={() => setOpenConfirm(false)}>Annulla</MDButton>
          <MDButton onClick={deleteObject} autoFocus>Conferma</MDButton>
        </DialogActions>
      </Dialog>
      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />
    </DashboardLayout>

  )
}
